module.exports = __webpack_public_path__ + "static/icon6-e0a302295093d1dcc8ce5a293e77948d.svg";